import axios from "axios";
import React, { Component } from "react";
import { toast } from "react-toastify";
import { Loader, Message } from "rsuite";
import api from "../../../http/global-vars";

class AddPaymentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        title: "",
        name: "",
        description: "",
      },
      isLoading: false,
      error: {},
      isEmpty: false,
      requestConfig: {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("userToken")}`,
        },
      },
      userID: window.localStorage.getItem("userID"),
      api: api,
    };
  }

  handleChange = (e) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;

    this.setState({
      fields: fields,
    });
  };

  onValidateFormData = () => {
    let fields = this.state.fields;
    let errors = this.state.error;
    var isValidForm = true;

    if (!fields["name"]) {
      isValidForm = false;
      this.setState({
        isEmpty: true,
      });
      setTimeout(() => {
        this.setState({
          isEmpty: false,
        });
      }, 5000);

      errors["name"] = "Veuillez renseigner le type depaiement!";
    }

    if (!fields["title"]) {
      isValidForm = false;
      this.setState({
        isEmpty: true,
      });
      setTimeout(() => {
        this.setState({
          isEmpty: false,
        });
      }, 5000);

      errors["title"] = "Veuillez renseigner le nom du mode de paiement!";
    }

    this.setState({
      error: errors,
    });

    return isValidForm;
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (this.onValidateFormData()) {
      this.setState({
        isLoading: true,
      });

      var api = this.state.api;
      var data = this.state.fields;

      axios
        .post(api + "paymentmode/", data, this.state.requestConfig)
        .then((response) => {
          console.log("la reponse", response);
          this.props.getpayments();
          window.$(".add-payment-modal").modal("hide");
          e.target.reset();
          this.setState({
            isLoading: false,
            fields: {
              title: "",
              name: null,
              description: "",
            },
            error: {},
          });
          toast.success("Mode de paiement ajouté avec succés.");
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
          });
          console.log("erreur", error.response);
        });
    }
  };

  render() {
    return (
      <div className="modal-dialog easypm-modal-dialog modal-lg">
        <div className="modal-content easypm-modal-content">
          <div className="modal-header easypm-modal-header">
            <h5
              className="modal-title easypm-modal-title"
              id="AddingFamilyModal"
            >
              Ajouter un mode de paiement
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body easypm-modal-body">
            <div className="add-family-form-container">
              <form className="crud-form" onSubmit={(e) => this.onSubmit(e)}>
                <div className="row crud-row">
                  <div className="col-md-6 crud-col-item">
                    <div className="form-group crud-form-group required">
                      <label for="last_name">Nom</label>
                      <input
                        type="text"
                        placeholder="Nom"
                        name="title"
                        onChange={this.handleChange}
                        className="form-control crud-form-control"
                        id="last_name"
                      />
                      {this.state.isEmpty === true &&
                        this.state.error?.title && (
                          <Message
                            className="alert-rsuite-custom"
                            type="error"
                            description={this.state.error.title}
                          />
                        )}
                    </div>
                  </div>
                  <div className="col-md-6 crud-col-item">
                    <div className="form-group crud-form-group required">
                      <label htmlFor="first_name">Type</label>
                      <div className="filter-item-container">
                        <select
                          name="name"
                          onChange={this.handleChange}
                          placeholder="Choisir un type"
                          className="form-control crud-form-control form-select form-select-line-chart ml-md-auto filter-select-item select-crud-form"
                          aria-label="Default select example"
                          style={{ padding: "10px", height: "46px" }}
                        >
                          <option value="">Choisir un type</option>
                          <option value="espece">En espèces</option>
                          <option value="electronique">Electronique</option>
                        </select>
                        {this.state.isEmpty === true &&
                          this.state.error?.name && (
                            <Message
                              className="alert-rsuite-custom"
                              type="error"
                              description={this.state.error.name}
                            />
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 crud-col-item">
                    <div className="form-group crud-form-group ">
                      <label for="dscrp">Description</label>
                      <textarea
                        className="form-control crud-form-control"
                        name="description"
                        id="dscrp"
                        placeholder="Saisissez la description"
                        onChange={this.handleChange}
                        cols="10"
                        rows="3"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-6 offset-md-6 crud-form-action-btn-container">
                    <button
                      className="btn btn-default cancelleb-btn"
                      data-dismiss="modal"
                    >
                      Retour
                    </button>
                    {!this.state.isLoading && (
                      <button className="btn btn-primary crud-submit-btn">
                        Enregistrer
                      </button>
                    )}
                    {this.state.isLoading && (
                      <button className="btn btn-primary crud-submit-btn">
                        En cours &nbsp;
                        <Loader />
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddPaymentModal;
